module.exports = __webpack_public_path__ + "img/Kebaruan-Value.07d9c087.png";